/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, input, output, AfterViewInit } from '@angular/core';
import { DatePicker } from 'primeng/datepicker';
import { SelectChangeEvent, SelectModule } from 'primeng/select';
import { DashboardTranslateKeys } from '../../utils/dashboard-translate-keys.enum';
import { TranslateModule } from '@ngx-translate/core';
import { FilterDashOption } from '../../utils/filters-dash.enum';
import { FormsModule } from '@angular/forms';

@Component({
  imports: [DatePicker, SelectModule, TranslateModule, FormsModule],
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrl: './filters.component.scss',
})
export class FiltersComponent implements AfterViewInit {
  disabled = input(false);
  softColor = input(false);
  showYearPicker = input(false);
  showMonthYearPicker = input(false);
  firstSelectOptions = input<FilterDashOption[]>([]);
  secondSelectOptions = input<FilterDashOption[]>([]);
  public yearSelected: Date = new Date();
  public monthYearSelected: Date = new Date();
  yearPickerChanged = output<string | null>();
  monthYearPickerChanged = output<string | null>();
  firstSelectChanged = output<string | null>();
  secondSelectChanged = output<string | null>();
  public DashboardTranslateKeys = DashboardTranslateKeys;
  get canDisplayFilter() {
    return (
      this.showYearPicker() ||
      this.showMonthYearPicker() ||
      this.firstSelectOptions().length ||
      this.secondSelectOptions().length
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.showYearPicker()) {
        this.onYearChange();
      }
      if (this.showMonthYearPicker()) {
        this.onMonthYearChange();
      }
    }, 0);
  }

  onYearChange() {
    this.yearPickerChanged.emit(
      this.yearSelected ? this.yearSelected.getFullYear().toString() : null,
    );
  }

  onMonthYearChange() {
    if (this.monthYearSelected) {
      const month = (this.monthYearSelected.getMonth() + 1)
        .toString()
        .padStart(2, '0');
      const year = this.monthYearSelected.getFullYear().toString();
      this.monthYearPickerChanged.emit(`${month}-${year}`);
    } else {
      this.monthYearPickerChanged.emit(null);
    }
  }

  onFirstSelectChanged($event: SelectChangeEvent) {
    this.firstSelectChanged.emit($event.value);
  }
  onSecondSelectChanged($event: SelectChangeEvent) {
    this.secondSelectChanged.emit($event.value);
  }
}
